// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Popover Component Styles */

.popover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: transparent;
  pointer-events: none;
}

.popover-container {
  background-color: var(--color-white);
  border: 1px solid var(--color-light-gray);
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  padding: 8px 0;
  min-width: 200px;
  max-width: 300px;
  pointer-events: auto;
  transition: opacity 0.2s ease;
}

.popover-option {
  display: block;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: var(--color-black);
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.popover-option:hover {
  background-color: var(--color-light-gray);
}

.popover-option:focus {
  outline: none;
  background-color: var(--color-light-gray);
}

.popover-option:active {
  background-color: var(--color-gray);
}

.popover-option.disabled {
  color: var(--color-gray);
  cursor: not-allowed;
  opacity: 0.6;
}

.popover-option.disabled:hover {
  background-color: transparent;
}

/* Responsive design */
@media (max-width: 768px) {
  .popover-container {
    min-width: 180px;
    max-width: 280px;
    padding: 6px 0;
  }
  
  .popover-option {
    padding: 10px 14px;
  }
}

@media (max-width: 480px) {
  .popover-container {
    min-width: 160px;
    max-width: 260px;
    padding: 4px 0;
  }
  
  .popover-option {
    padding: 8px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Popover/Popover.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Popover Component Styles */\n\n.popover-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  background-color: transparent;\n  pointer-events: none;\n}\n\n.popover-container {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-light-gray);\n  border-radius: 8px;\n  box-shadow: var(--shadow-lg);\n  padding: 8px 0;\n  min-width: 200px;\n  max-width: 300px;\n  pointer-events: auto;\n  transition: opacity 0.2s ease;\n}\n\n.popover-option {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  color: var(--color-black);\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.popover-option:hover {\n  background-color: var(--color-light-gray);\n}\n\n.popover-option:focus {\n  outline: none;\n  background-color: var(--color-light-gray);\n}\n\n.popover-option:active {\n  background-color: var(--color-gray);\n}\n\n.popover-option.disabled {\n  color: var(--color-gray);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.popover-option.disabled:hover {\n  background-color: transparent;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .popover-container {\n    min-width: 180px;\n    max-width: 280px;\n    padding: 6px 0;\n  }\n  \n  .popover-option {\n    padding: 10px 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .popover-container {\n    min-width: 160px;\n    max-width: 260px;\n    padding: 4px 0;\n  }\n  \n  .popover-option {\n    padding: 8px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
